import { render, staticRenderFns } from "./CoTwoWasteForm.vue?vue&type=template&id=7e8c0446&scoped=true&"
import script from "./CoTwoWasteForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoWasteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8c0446",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e8c0446')) {
      api.createRecord('7e8c0446', component.options)
    } else {
      api.reload('7e8c0446', component.options)
    }
    module.hot.accept("./CoTwoWasteForm.vue?vue&type=template&id=7e8c0446&scoped=true&", function () {
      api.rerender('7e8c0446', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoWasteForm.vue"
export default component.exports